import { createRoute, redirect } from '@tanstack/react-router';
import { lazyPage } from '../common';
import { siteRoute } from '../layouts';
import { oauthLeaves } from './oauth';

const pages = () => import('./pages');
const platformComp = lazyPage(pages, 'PlatformHost');
const metafieldsComp = lazyPage(pages, 'MetafieldsHost');
const partnersComp = lazyPage(pages, 'PartnersHost');
const productsSyncComp = lazyPage(pages, 'ProductsSyncHost');
const productDataComp = lazyPage(pages, 'ProductDataHost');

// /integrations redirects to the platform page.
const integrationsIndexRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'integrations',
  beforeLoad({ params }) {
    throw redirect({ to: '/$siteId/$siteEnv/integrations/platform', params });
  },
});

const integrationsPlatformRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'integrations/platform',
  component: platformComp,
  staticData: { title: 'Integrations - Platform' },
});

const integrationsPlatformMetafieldsRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'integrations/platform/metafields',
  component: metafieldsComp,
  staticData: { title: 'Integrations - Platform - Metafields' },
});

const integrationsPartnersRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'integrations/partners',
  component: partnersComp,
  staticData: { title: 'Integrations - Partners' },
});

// Legacy customers-sync URLs -> the customers list.
const integrationsCustomersSyncRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'integrations/customers-sync',
  beforeLoad({ params }) {
    throw redirect({ to: '/$siteId/$siteEnv/customers/list', params });
  },
});

const integrationsCustomerSyncDataRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'integrations/customers-sync/$identifier',
  beforeLoad({ params }) {
    throw redirect({
      to: '/$siteId/$siteEnv/customers/list',
      params: { siteId: params.siteId, siteEnv: params.siteEnv },
    });
  },
});

const integrationsProductsSyncRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'integrations/products-sync',
  component: productsSyncComp,
  staticData: { title: 'Integrations - Products Sync' },
});

const integrationsProductDataRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'integrations/products-sync/$variantSku',
  component: productDataComp,
  staticData: { title: 'Integrations - Product Data' },
});

// Legacy widgets URLs on the integrations tree -> the storefront widgets pages.
const integrationsWidgetsRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'integrations/widgets',
  beforeLoad({ params }) {
    throw redirect({ to: '/$siteId/$siteEnv/storefront/widgets', params });
  },
});

const integrationsWidgetsCoreRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'integrations/widgets/core',
  beforeLoad({ params }) {
    throw redirect({ to: '/$siteId/$siteEnv/storefront/widgets/core', params });
  },
});

const integrationsWidgetsPdpRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'integrations/widgets/pdp',
  beforeLoad({ params }) {
    throw redirect({ to: '/$siteId/$siteEnv/storefront/widgets/pdp', params });
  },
});

const integrationsWidgetsCssRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'integrations/widgets/css',
  beforeLoad({ params }) {
    throw redirect({ to: '/$siteId/$siteEnv/storefront/widgets/css', params });
  },
});

const integrationsWidgetsTipsRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'integrations/widgets/tips',
  beforeLoad({ params }) {
    throw redirect({ to: '/$siteId/$siteEnv/storefront/widgets/tips', params });
  },
});

/** Integrations family leaves to attach under the site-env layout. */
export const integrationsLeaves = [
  integrationsIndexRoute,
  integrationsPlatformRoute,
  integrationsPlatformMetafieldsRoute,
  integrationsPartnersRoute,
  ...oauthLeaves,
  integrationsCustomersSyncRoute,
  integrationsCustomerSyncDataRoute,
  integrationsProductsSyncRoute,
  integrationsProductDataRoute,
  integrationsWidgetsRoute,
  integrationsWidgetsCoreRoute,
  integrationsWidgetsPdpRoute,
  integrationsWidgetsCssRoute,
  integrationsWidgetsTipsRoute,
];
